angular.module('unica_auth.auth_controllers')

.controller('LogoutController', function(
	$rootScope, $scope, $state, $timeout,
	LogoutService ) {

	$scope.showLoader();

	LogoutService.logout().then(function(data) {
		$scope.hideLoader();

		if (!data.error) {
			$scope.showSuccessMsg('Logout effettuato con successo!', '');
			$rootScope.setCurrentUser( null );
		} else {
			$scope.showErrorMsg('Errore', data.error);
		}
		$state.go('app.auth_logout_success');
	});

});